/* eslint-disable */
import router from '@ps/router'
import { readFile, saveFile } from '@ps/api/editor/file'
import {
  asyncMethod,
  GameState,
  NormalEvent,
  ScreenActionMap,
  ScreenActionType,
  VirtualJoystick,
  VPvariableDataType,
} from '@ps/utils/config'
import {
  deleteScript,
  DFS,
  ensureScript,
  findChildByRouteIndexInScene,
  generateUUID,
  getGamePlay,
  getRouteIndexByNodeInScene,
  isUUID,
  isVPComponent,
  qcNodeReloadScript,
  qcNodeRemoveScript,
  reloadScript,
} from '@ps/utils/game'
import _, { cloneDeep } from 'lodash'
import { Vue } from 'vue-property-decorator'
import i18n from '@ps/lang'
import {
  executeAction,
  getAddEvent,
  getBatchDelActions,
  getChangeEventToOtherSceneAction,
  getEventAddActionHistory,
  getEventEditAction,
  getEventRemoveActionHistory,
  getChangeEventActionFilter,
  getRemoveEvent,
  getAddCompareCondition,
  getEditCompareCondition,
  getDeleteCompareCondition,
  getDeleteCompareConditions,
  getEditConditionsForTypeChangeHistory,
  getEditEventNameHistory,
} from '@ps/workbench/undo-redo'
import {
  astItemFactory,
  getActionEventConfig,
  getActionsFromNode,
  getParamLabelUI,
  makeAction,
  updateDrawLineParamLabel,
} from './utils'
import iframe from '@ps/bridge/iframe/iframe'
import store from '@ps/store'
import nodePool from '@ps/bridge/qc/node-pool'
import { getVpAstFromSceneNode } from '@ps/bridge/qc/vp'
import {
  AudioConditionType,
  DragConditionType,
  HandConditionType,
  VideoConditionType,
  CarouselConditionType,
  getVpAstActionConfig,
  CustomEventType,
  DrawLineConditionType,
  VpMethods,
  EraseConditionType,
  VpTweenMethods
} from '@ps/bridge/qc/vp/config'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import {
  getEventItemGroupById,
  hasPlaysmartGlobalVars,
} from '@ps/store/workbench/visual-program/utils'
import { getSceneNodeByUuid, hasDrawLineConnectInScene, getDrawLineInScene, isDrawLineAreaNode } from '@ps/bridge/qc/base'
import { isNormalScene } from '@ps/bridge/qc/scripts/scene-config'
import { scripts } from '@ps/bridge/qc/scripts'
import { language } from '@/common/storage'
import { i18nParamParse } from './i18nParam'
import { i18nLayerName } from '@ps/views/workbench/layer-manager/layer'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { resolveTimeline } from '@ps/store/interactive-video/timeline/timeline'
import { getEditConditionHistory, getSortCompareConditionEventHistory } from '@ps/workbench/undo-redo/module/event-setting-action'
import { isIvPage } from '@ps/router/config'

// 用来区分新旧ps的脚本数据,新ps是有这个数据,旧版没有
export const VERSION = 'ps2'
const VARIABLE_TYPE = {
  string: {
    serialize: 'qc.Serializer.STRING',
    label: i18n.t('workbench.eventSetting.visualProgram.variableType.string'),
  },
  number: {
    serialize: 'qc.Serializer.NUMBER',
    label: i18n.t('workbench.eventSetting.visualProgram.variableType.number'),
  },
  boolean: {
    serialize: 'qc.Serializer.BOOLEAN',
    label: i18n.t('workbench.eventSetting.visualProgram.variableType.boolean'),
  },
}
let gamePlayCodeText = ''

export function getVpAstLockFromSceneNode(node) {
  const playsmartEditorData = ensureScript(node, 'playsmart.editor.data')
  return !!_.get(playsmartEditorData, 'vpAstLock')
}

export async function checkGlobalVarSupport() {
  const defineCodeReg = new RegExp(
    `(// ## scope variable ##)([\\w\\W]*)(// ## scope variable ##)`,
  )
  const gamePlayCode = await getVPGamePlayCode()
  if (
    gamePlayCode.code === 1 ||
    typeof iframe.gamePlay.vpCompute === 'undefined'
  ) {
    // 不存在Scripts/vp/VPGamePlay.js或者没有vpCompute方法的就不开通全局变量权限
    return false
  }
  return gamePlayCode.match(defineCodeReg)
}

// 递归检查对象有无value等于value
const hasValue = (obj, value) => {
  if (typeof obj !== 'object') return obj === value
  return (
    obj &&
    (Object.values(obj).includes(value) ||
      Object.values(obj).some((val) => hasValue(val, value)))
  )
}

export const getEventsToNode = ({ nodeId }) => {
  const sceneList = iframe.gamePlay.children

  const ret = { condition: [], action: [] }
  sceneList.forEach((sceneNode) => {
    const ast = getVpAstFromSceneNode(sceneNode)
    ast.forEach((astItem, astIndex) => {
      Array.isArray(astItem.condition) &&
        astItem.condition.forEach((con, conIndex) => {
          if (hasValue(con, nodeId)) {
            ret.condition.push({
              astIndex,
              index: conIndex,
              value: _.cloneDeep(con),
              sceneId: sceneNode.uuid,
            })
          }
        })
      Array.isArray(astItem.action) &&
        astItem.action.forEach((act, actIndex) => {
          if (hasValue(act, nodeId)) {
            ret.action.push({
              astIndex,
              index: actIndex,
              value: _.cloneDeep(act),
              sceneId: sceneNode.uuid,
            })
          }
        })
    })
  })
  return ret
}

export const getEventsOnNode = ({ sceneId }) => {
  const sceneNode = nodePool.find(sceneId)
  return _.cloneDeep(getVpAstFromSceneNode(sceneNode))
}
// 根据动画id获取对应的action
export const getActionsByAnimation = ({ animationId }) => {
  const sceneList = iframe.gamePlay.children
  const ret = { condition: [], action: [] }
  sceneList.forEach((sceneNode) => {
    const ast = getVpAstFromSceneNode(sceneNode)
    ast.forEach((astItem, astIndex) => {
      Array.isArray(astItem.action) &&
        astItem.action.forEach((act, actIndex) => {
          if (hasValue(act, animationId)) {
            ret.action.push({
              astIndex,
              index: actIndex,
              value: _.cloneDeep(act),
              sceneId: sceneNode.uuid,
            })
          }
        })
    })
  })
  return ret
}
// 根据node和targetList(支持多选响应对象)获取对应的全局动画action
export const getVpPlayTweenAnimationsFromNode = (node) => {
  const sceneList = iframe.gamePlay.children
  const uuid = node.uuid
  const ret = { condition: [], action: [] }
  sceneList.forEach((sceneNode) => {
    const ast = getVpAstFromSceneNode(sceneNode)
    ast.forEach((astItem, astIndex) => {
      Array.isArray(astItem.action) &&
        astItem.action.forEach((act, actIndex) => {
          if (
            (['vpPlayTween', 'vpStopTween', 'vpPlayTweenGoOn'].includes(
              act.method,
            ) &&
            act.node === uuid) || (act.targetList && act.targetList.indexOf(uuid) > -1)
          ) {
            ret.action.push({
              astIndex,
              index: actIndex,
              value: _.cloneDeep(act),
              sceneId: sceneNode.uuid,
            })
          }
        })
    })
  })
  return ret
}
// 获取含[播放分组里的动画]的action
export const getActionsWithTweenChildrenAll = () => {
  const currentSceneNode = store.state.workspace.game.sceneManager.currentSceneNode
  const actions = []
  const ast = getVpAstFromSceneNode(currentSceneNode)
  ast.forEach((astItem, astIndex) => {
    Array.isArray(astItem.action) &&
      astItem.action.forEach((act, actIndex) => {
        if (
          [VpTweenMethods.vpPlayTweenChildrenAll, VpTweenMethods.vpStopTweenChildrenAll, VpTweenMethods.vpPlayTweenChildrenAllGoOn].includes(
            act.method,
          )
        ) {
          actions.push({
            astIndex,
            index: actIndex,
            value: _.cloneDeep(act),
            sceneId: currentSceneNode.uuid,
          })
        }
      })
  })
  return actions
}
/**
 * @description 从定义注释中获取全局变量的描述
 * @returns {key: string}
 */
async function getGlobalVarDesc() {
  const defineCodeReg = new RegExp(
    `(// ## scope variable ##)([\\w\\W]*)(// ## scope variable ##)`,
  )
  const gamePlayCode = await getVPGamePlayCode()
  if (!gamePlayCode.match(defineCodeReg)) return
  const defineCode = gamePlayCode
    .match(defineCodeReg)[2]
    .split('\n')
    .filter((e) => e)

  const desc = {}
  let tempDesc
  defineCode.forEach((string, index) => {
    if (index % 2) {
      if (/_this\.(.*) =/.test(string)) {
        desc[string.match(/_this\.(.*) =/)[1]] = tempDesc
      }
    } else {
      let d = string.replace('// ', '')
      if (d === 'undefined') d = ''
      tempDesc = d
    }
  })
  return desc
}

/**
 * @description 根据用户定义的全局变量解析出全局变量定义的代码
 * @param {Array} globalVar 全局变量数组
 * @returns {defineCode: String, serializeCode: String}
 */
function getGlobalVarDefineCode(globalVar) {
  const resolveDefineCode = ({ id, type, globalVarKey, value, desc }) => {
    let code, name
    if (hasPlaysmartGlobalVars()) {
      name = id
    } else {
      name = globalVarKey
    }
    if (type === 'string') {
      code = `_this.${name} = "${value.replace(/"/g, '\\"')}"` // 名称需要转义双引号
    } else {
      code = `_this.${name} = ${value}`
    }
    code = `// ${desc}\n${code}`
    return code
  }
  const resolveSerializeCode = ({ id, type, globalVarKey }) => {
    if (hasPlaysmartGlobalVars()) {
      return `${id}: ${VARIABLE_TYPE[type].serialize}\n`
    } else {
      return `${globalVarKey}: ${VARIABLE_TYPE[type].serialize}\n`
    }
  }
  const defineCode = globalVar.map((v) => resolveDefineCode(v)).join('\n')
  const serializeCode = globalVar.map((v) => resolveSerializeCode(v)).join(',')
  return {
    defineCode,
    serializeCode,
  }
}

/**
 * @description 把定义全局变量的代码 hard code 到VPGamePlay中
 * @param {Array} globalVar
 * @param {String} VPGamePlayCode
 * @returns {String} code
 */
function resolveGlobalVarCode(globalVar, VPGamePlayCode) {
  const variableRegExp = new RegExp(
    `(// ## scope variable ##)([\\w\\W]*)(// ## scope variable ##)`,
  )
  const serializeRegExp = new RegExp(
    `(// ## serialize ##)([\\w\\W]*)(// ## serialize ##)`,
  )
  const { defineCode, serializeCode } = getGlobalVarDefineCode(globalVar)
  return VPGamePlayCode.replace(
    variableRegExp,
    `$1\n${defineCode}\n$3`,
  ).replace(serializeRegExp, `$1\n${serializeCode}\n$3`)
}

async function getVPGamePlayCode() {
  if (gamePlayCodeText === '') {
    const VPGamePlayPath = 'Scripts/vp/VPGamePlay.js'
    const code = await readFile({
      pid: router.currentRoute.query.id,
      path: VPGamePlayPath,
    })
    if (typeof code === 'string') {
      gamePlayCodeText = code
    }
    return code
  } else {
    return gamePlayCodeText
  }
}

export function findIndexEventCondition(condition) {
  return condition.findIndex((c) => c.type === 'event')
}

export function timerIdGenerator(timers) {
  if (!timers) return '定时器_0'
  const timerArr = []
  for (const i in timers) {
    timerArr.push(i)
  }
  let autoTimersId = timerArr
    .filter(function (timer) {
      return /^定时器_/.test(timer)
    })
    .map(function (timer) {
      return timer.replace('定时器_', '')
    })
    .sort()
    .pop()
  if (typeof autoTimersId !== 'undefined') {
    let timerId = '定时器_' + ++autoTimersId
    while (timerId in timers) {
      timerId = '定时器_' + ++autoTimersId
    }
    return timerId
  }
  return '定时器_0'
}

/**
 * 解析ast的condtion为代码
 * @param {Array} condition 一个event内的condition
 * @param {Object} nodePool
 * @param {String} eventUUID
 */

function resolveConditionCode(condition, nodePool, id) {
  let conditionCode = ''
  let defineTempVarCode = ''
  // 是否有属于事件类型的条件
  const eventConditionIndex = findIndexEventCondition(condition)
  const conditionReplaceReg =
    eventConditionIndex === -1
      ? new RegExp(`(// ## update ##)([\\w\\W]*)(// ## update ##)`)
      : new RegExp(`(// ## awake ##)([\\w\\W]*)(// ## awake ##)`)
  const conditionIf = ['!0']
  if (eventConditionIndex === -1) {
    // 插入到update的类型
    const tempVar = `_${id}`
    const eventTempVarRegTag = `temp var ${id}`
    defineTempVarCode = `
      // ${eventTempVarRegTag}
      _this.${tempVar} = true
      // ${eventTempVarRegTag}
      `
    // 清除原有的定义代码
    conditionIf.push(`this.${tempVar}`)
    conditionCode = `
        if(/** ## if ## */ !0 /** ## if ## */) {
          this.${tempVar} = false
          // ## action ##

          // ## action ##
        }
      `
  } else {
    // 插入到awake的类型
    const tempVar = `_${id}`
    const eventTempVarRegTag = `temp var ${id}`
    defineTempVarCode = `
      // ${eventTempVarRegTag}
      _this.${tempVar} = true
      // ${eventTempVarRegTag}
      `
    // 清除原有的定义代码
    conditionIf.push(`this.${tempVar}`)
    const eventCondition = condition[eventConditionIndex]
    let isCommonEventTemplate = false
    // 手势类型
    if (Object.values(HandConditionType).includes(eventCondition.content)) {
      const node = nodePool.find(eventCondition.node)
      if (node && !node.getScript('ps.VPHand')) {
        const vpHand = node.addScript('ps.VPHand')
        vpHand.version = VERSION
      }
      // 只有普通场景才加interactive
      if (isNormalScene(node)) {
        conditionCode += `this.gameObject.interactive = true\n`
      }
      conditionIf.push(`('${eventCondition.node}' === uuid || '${eventCondition.node}' === uniqueName)`)
      isCommonEventTemplate = true
    } else if (eventCondition.content === GameState.SCENECHANGE) {
      // 切换场景或拖拽
      conditionIf.push('this.gameObject.uuid === uuid')
      isCommonEventTemplate = true
    } else if (eventCondition.content === NormalEvent.VPEMITEVENT) {
      // 需要if判断的事件条件
      conditionIf.push(`uuid === "${eventCondition.params.event}"`)
      isCommonEventTemplate = true
    } else if (
      eventCondition.content === 'DEVICE_ROTATE_P' ||
      eventCondition.content === 'DEVICE_ROTATE_L'
    ) {
      // 不需要if过滤的条件
      isCommonEventTemplate = true
    } else if (
      eventCondition.content === VideoConditionType.VIDEO_PLAY_START ||
      eventCondition.content === VideoConditionType.VIDEO_PLAY_END ||
      eventCondition.content === AudioConditionType.AUDIO_PLAY_START ||
      eventCondition.content === AudioConditionType.AUDIO_PLAY_END ||
      eventCondition.content === DrawLineConditionType.FREE_DRAW_START ||
      eventCondition.content === DrawLineConditionType.FREE_DRAW_END ||
      eventCondition.content === EraseConditionType.ERASE_START ||
      eventCondition.content === EraseConditionType.ERASE_UP
    ) {
      // 视频音效播放事件,自由画线事件,擦除事件
      conditionCode += `
          main.gameEvent.add("${eventCondition.content}", async function(uuid){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      conditionIf.push(`"${eventCondition.node}" === uuid`)
      isCommonEventTemplate = false
    } else if (
      Object.values(ScreenActionType).includes(eventCondition.content)
    ) {
      conditionCode += `
          this.gameObject.addListener(qc_game.input.${
            ScreenActionMap[eventCondition.content]
          }, async function(){
            if(/** ## if ## */ !0 /** ## if ## */) {
            // ## action ##

            // ## action ##
            }
          }, ps);
        `
      isCommonEventTemplate = false
    } else if (
      Object.values(VirtualJoystick).includes(eventCondition.content)
    ) {
      isCommonEventTemplate = true
    } else if (eventCondition.content === DragConditionType.VPDRAG_START) {
      const node = nodePool.find(eventCondition.node)
      if (node) {
        let drager = node.getScript('ps.Drager')
        if (!drager) {
          drager = node.addScript('ps.Drager')
          drager.version = VERSION
        }
        if (eventCondition.dragDirection) {
          drager.dragDirection = eventCondition.dragDirection
        }
        drager.dragResetPos = eventCondition.dragResetPos
        if (eventCondition.ext && eventCondition.ext.dragBound) {
          drager.dragBound = nodePool.find(eventCondition.ext.dragBound)
        }
      }
      conditionCode += `
          gameEvent.add("${eventCondition.content}", async function(uuid, uniqueName){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      conditionIf.push(`("${eventCondition.node}" === uuid || "${eventCondition.node}" === uniqueName)`)
      isCommonEventTemplate = false
    } else if (eventCondition.content === DragConditionType.VPDRAG_END || eventCondition.content === DragConditionType.VPUNDRAG_END) {
      const dragObj = nodePool.find(eventCondition.node)
      if (dragObj) {
        let drag = dragObj.getScript('ps.Drager')
        if (!drag) {
          drag = dragObj.addScript('ps.Drager')
          drag.version = VERSION
        }
        if (eventCondition.dragDirection) {
          drag.dragDirection = eventCondition.dragDirection
        }
        if (eventCondition.ext && eventCondition.ext.dragBound) {
          drag.dragBound = nodePool.find(eventCondition.ext.dragBound)
        }
        drag.targetAreaList[eventCondition.node2] = []
        if (
          eventCondition.ext &&
          eventCondition.ext.dragTargetArea &&
          eventCondition.ext.dragTargetArea[eventCondition.node2].length > 0
        ) {
          eventCondition.ext.dragTargetArea[eventCondition.node2].forEach(
            (uuid) => {
              drag.targetAreaList[eventCondition.node2].push(uuid)
              const node = nodePool.find(uuid)
              if (!node) return
              const dt = node.getScript('ps.DragTarget')
              dt.dragResetPos = eventCondition.dragResetPos
              if (eventCondition.content === DragConditionType.VPDRAG_END) {
                dt.isDragEvent = true
              } else if (eventCondition.content === DragConditionType.VPUNDRAG_END) {
                dt.isDragEvent = false
              }
            },
          )
        }
      }

      conditionCode += `
          gameEvent.add("${eventCondition.content}", async function(uuid){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      conditionIf.push(`"${eventCondition.node2}" === uuid`)
      isCommonEventTemplate = false
    } else if (eventCondition.content === CustomEventType.CUSTOM_EVENT) {
      conditionIf.push(`'${tempVar}' === '_' + uuid`)
      isCommonEventTemplate = true
    } else if (
      eventCondition.content === DrawLineConditionType.DRAW_START
    ) {
      // 开始画线
      conditionCode += `
          main.gameEvent.add("${eventCondition.content}", async function(uuid){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      if (eventCondition.drawLineStartNode) {
        const nodes = eventCondition.drawLineStartNode
        const drawLineNode = nodePool.find(eventCondition.node)
        let hardCode = ''
        const uuids = nodes.map((name) => {
          const node = drawLineNode.getChild(name)
          return `"${node.uuid}"`
        })
        hardCode = `[${uuids.join(',')}]`
        conditionIf.push(`${hardCode}.indexOf(uuid) > -1`)
      }
      isCommonEventTemplate = false
    } else if (
      eventCondition.content === DrawLineConditionType.DRAW_END
    ) {
      if (typeof eventCondition.isMatch !== 'undefined') {
        // 画线结束
        const param = 'startUuid, endUuid, pairCategory, sceneNodeUuid'
        conditionCode += `
            main.gameEvent.add("${eventCondition.content}", async function(${param}){
              if(/** ## if ## */ !0 /** ## if ## */) {
                // ## action ##

                // ## action ##
              }
            }, this)
          `
        if (eventCondition.isMatch === 1) {
          const node = nodePool.find(eventCondition.node)
          let drawLineData = node.getScript('playsmart.editor.data').$data.drawLineData
          let dlc = node.getScript(scripts.drawLine.name)
          const pairDir = dlc.pairingDirection === 'oneWay' ? 1: 2
          drawLineData = JSON.parse(drawLineData)
          let pairCode = []
          if (eventCondition.pairsUuid && eventCondition.pairsUuid.length > 0) {
            drawLineData.forEach((pair) => {
              if (pair.startArea === '' || pair.endArea.length === 0) return
              if (eventCondition.pairsUuid.indexOf(pair.uuid) > -1) {
                const startAreaNode = node.getChild(pair.startArea)
                const endUuids = pair.endArea.map((name) => {
                  const n = node.getChild(name)
                  return `"${n.uuid}"`
                })
                const code = `[${endUuids.join(',')}]`
                pairCode.push(`("${startAreaNode.uuid}" === startUuid && ${code}.indexOf(endUuid) > -1)`)
                // 双向
                if (pairDir === 2) {
                  pairCode.push(`("${startAreaNode.uuid}" === endUuid && ${code}.indexOf(startUuid) > -1)`)
                }
              }
            })
          }
          if (eventCondition.pairCategory) {
            pairCode.push(`"${eventCondition.pairCategory}" === pairCategory && this.gameObject.visible`)
          }
          if (pairCode.length === 0) {
            pairCode = 'false'
          } else {
            pairCode = pairCode.join('||')
            pairCode = `(${pairCode})`
          }
          conditionIf.push(pairCode)
        } else if (eventCondition.isMatch === 2) {
          conditionIf.push(`typeof endUuid === 'undefined'`)
        }
      }
      isCommonEventTemplate = false
    } else if (eventCondition.content === EraseConditionType.ERASE_REACH_STEP || eventCondition.content === EraseConditionType.ERASE_UN_REACH_STEP) {
      // 擦除到达和未到达某一阶段
      conditionCode += `
          main.gameEvent.add("${eventCondition.content}", async function(uuid, customEventId, step){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      if (eventCondition.erase && eventCondition.erase.customEventId && eventCondition.erase.step) {
        const node = nodePool.find(eventCondition.node)
        const eraseComponent = node.getScript(scripts.erase.name)
        const eventItem = Object.values(eraseComponent.customEvents).find(item => item.id === eventCondition.erase.customEventId)
        const step = eventItem.step[eventCondition.erase.step]
        conditionIf.push(`"${eventCondition.node}" === uuid`)
        conditionIf.push(`"${eventCondition.erase.customEventId}" === customEventId`)
        conditionIf.push(`${step} === step`)
      }
      isCommonEventTemplate = false
    } else if (eventCondition.content === CarouselConditionType.SWITCH_DONE) {
      conditionCode += `
          main.gameEvent.add("${CarouselConditionType.SWITCH_DONE}", async function(carouselData, uuid){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      if (eventCondition.carousel && eventCondition.carousel.carouselId) {
        // const node = nodePool.find(eventCondition.node)
        // const carouselComponent = node.getScript(scripts.carousel.name)
        conditionIf.push(`carouselData.find(item => item.current && item.carouselId === "${eventCondition.carousel.carouselId}")`)
      }
      isCommonEventTemplate = false
    } else if (eventCondition.content === CarouselConditionType.RESOURCE_SWITCH_DONE) { // 轮播到指定资源
      conditionCode += `
          main.gameEvent.add("${CarouselConditionType.SWITCH_DONE}", async function(carouselData, uuid){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      if (eventCondition.carousel && eventCondition.carousel.carouselId && eventCondition.carousel.resourceUniqueNames) {
        // const node = nodePool.find(eventCondition.node)
        // const carouselComponent = node.getScript(scripts.carousel.name)
        conditionIf.push(`carouselData.find(item => item.carouselId === "${eventCondition.carousel.carouselId}" && "${ eventCondition.carousel.resourceUniqueNames.join(',') }".indexOf(item.uniqueName) > -1)`)
      }
      isCommonEventTemplate = false
    } else if (eventCondition.content === CarouselConditionType.TAG_SWITCH_DONE) { // 轮播到指定类型
      conditionCode += `
          main.gameEvent.add("${CarouselConditionType.SWITCH_DONE}", async function(carouselData){
            if(/** ## if ## */ !0 /** ## if ## */) {
              // ## action ##

              // ## action ##
            }
          }, this)
        `
      if (eventCondition.carousel && eventCondition.carousel.carouselIds && eventCondition.carousel.tagId) {
        const node = nodePool.find(eventCondition.node)
        const data = editorScript.getScript(node)
        // 轮播组件资源标签映射表
        const tagMap = data.$data.tagMap || {}
        const tagResourceList = (tagMap[eventCondition.carousel.tagId] || []).join(',')
        conditionIf.push(`carouselData.filter(item => "${eventCondition.carousel.carouselIds}".indexOf(item.carouselId) > -1).every(item => "${ tagResourceList }".indexOf(item.uniqueName) > -1)`)
      }
      isCommonEventTemplate = false
    }

    if (isCommonEventTemplate) {
      // 事件监听
      conditionCode += `
        ps.mainState.add("${eventCondition.content}", async function(uuid, uniqueName){
          if(/** ## if ## */ !0 /** ## if ## */) {
            // ## action ##

            // ## action ##
          }
        }, this)
        `
    }
  }

  // 碰撞检测条件
  const resolveRectContainCode = (condition, conditionIf) => {
    const con = condition.find((c) => c.type === 'rectcontains')
    if (!con) return
    const targetNode = `qc_game.nodePool.find('${con.params.node}')`
    conditionIf.push(
      `qc_game.nodePool.find('${con.node}').rectContains(${targetNode}.parent.toGlobal(${targetNode}))`,
    )
  }

  resolveRectContainCode(condition, conditionIf)
  // 渠道条件
  const resolveChannelCode = (condition, conditionIf) => {
    const con = condition.find((c) => c.type === 'channel')
    if (!con) return
    conditionIf.push(
      `window.MW_CONFIG && window.MW_CONFIG.channel === '${con.params.channel}'`,
    )
  }

  resolveChannelCode(condition, conditionIf)

  // 仓库参数条件
  const resolveMwConfigCode = (condition, conditionIf) => {
    const con = condition.find((c) => c.type === 'MwConfig')
    if (!con) return
    conditionIf.push(
      `window.MW_CONFIG && window.MW_CONFIG.${con.params.MwConfig} === ${con.params.booleanValue}`,
    )
  }

  resolveMwConfigCode(condition, conditionIf)

  // 兼容新旧版数据结构
  const getCompareParams = (condition) => {
    let params = condition.content
    if (
      [
        'compareData1',
        'compareMethod',
        'compareData2Type',
        'compareData2',
      ].every((key) => typeof condition.params[key] !== 'undefined')
    ) {
      params = condition.params
    }
    return params
  }
  const resolveCompareCode = ({
    compareData1,
    compareMethod,
    compareData2Type,
    compareData2,
  }) => {
    const resolveStringData = (data) => {
      if (Number.isNaN(Number(data))) {
        if (/^GAME_CFG\./.test(data)) {
          return data
        }
        return `"${data}"`
      }
      return data
    }
    const resolveCompareData = (compareData) => {
      if (typeof compareData === 'boolean') {
        if (compareData) return 'true'
        return 'false'
      }
      const { targetNode, targetNodeScript, data } = compareData
      if (targetNode && targetNodeScript) {
        const gamePlay = getGamePlay()
        const playsmartGlobalVars =
          gamePlay.getScript('ps.VPGamePlay').playsmartGlobalVars
        let ansData
        if (playsmartGlobalVars) {
          ansData = Object.values(playsmartGlobalVars).find(
            (item) => item.globalVarKey === data,
          ).id
        } else {
          ansData = data
        }
        return `qc_game.nodePool.find('${targetNode}').getScript('${targetNodeScript}').${ansData}`
      }
      return resolveStringData(data)
    }
    const resolveGameCFG = (compareData) => {
      if (/^GAME_CFG\./.test(compareData)) {
        return compareData
      }
      return `GAME_CFG.${compareData}`
    }
    // compareData1为字符串的情况有：动态参数
    const data1 =
      typeof compareData1 === 'string'
        ? resolveGameCFG(compareData1)
        : resolveCompareData(compareData1)
    // 兼容旧版数据结构compareData2是对象
    let data2
    if (compareData2Type === 'number') {
      data2 = compareData2
    } else if (compareData2Type === 'string') {
      data2 = `"${compareData2.replace(/"/g, '\\"')}"`
    } else if (compareData2Type === 'boolean') {
      if (compareData2) {
        data2 = 'true'
      } else {
        data2 = 'false'
      }
    } else if (compareData2Type === 'globalVar') {
      data2 = resolveCompareData(compareData2)
    }
    return `${data1} ${compareMethod} ${data2}`
  }

  // 比较条件
  condition.forEach((con, index) => {
    if (con.type === 'conditionIf') {
      conditionIf.push(...con.conditionIf)
      return
    }
    if (con.type !== 'compare' || index === eventConditionIndex) return
    if (
      typeof con.params === 'undefined' ||
      typeof con.params.compareData1 === 'undefined'
    )
      return
    const compareParams = getCompareParams(con)
    const compareCode = resolveCompareCode(compareParams) || '!0'
    conditionIf.push(compareCode)
  })
  if (conditionIf.length > 2) {
    conditionCode = conditionCode.replace(
      /(\/\*\* ## if ## \*\/)(.*)(\/\*\* ## if ## \*\/)/g,
      `${conditionIf.join('&&')}`,
    )
  } else {
    conditionCode = ''
  }

  return {
    conditionReplaceReg,
    conditionCode,
    defineTempVarCode,
  }
}

/**
 * 解析ast的action为代码
 * @param {Array} action 一个event内的action
 */
function resolveActionCode(action, eventItems) {
  // 解析param到代码，如果不是compute方法的话GAME_CFG不带双引号
  const resolveActionParam = (method, param = {}) => {
    const stringify = JSON.stringify(param)
    if (method === 'compute') return stringify
    return stringify.replace(/"GAME_CFG.([^"]*)"/g, 'GAME_CFG.$1')
  }

  let actionCode = ''
  action.forEach((act) => {
    // 异步操作
    const awaitCode = asyncMethod.includes(act.method) ? 'await' : ''
    if (act.script === '') {
      if (act.method === 'enabledEvent') {
        actionCode += `_this._${act.param.eventId}=${act.param.enabled}\n`
      } else if (act.method === 'enabledEventActive') {
        const eventAst = getEventItemGroupById(eventItems, act.param.eventId, true)
        const eventAstIds = eventAst.map((item) => item.id)
        eventAstIds.forEach((item) => {
          actionCode += `_this._${item}=true\n`
        })
        // 启用事件时开启手势交互
        eventAst.forEach((item) => {
          const uuid = item.condition[0].node
          actionCode += `qc_game.nodePool.find('${uuid}').interactive=true\n`
        })
      } else if (act.method === 'enabledEventBan') {
        const eventAst = getEventItemGroupById(eventItems, act.param.eventId, true)
        const eventAstIds = eventAst.map((item) => item.id)
        eventAstIds.forEach((item) => {
          actionCode += `_this._${item}=false\n`
        })
        // 禁用事件时需要禁用手势交互
        eventAst.forEach((item) => {
          const uuid = item.condition[0].node
          actionCode += `qc_game.nodePool.find('${uuid}').interactive=false\n`
        })
      } else {
        // 内建自带行为
        if (act.targetList && act.targetList.length > 0) {
          act.targetList.forEach((item) => {
            actionCode += `${awaitCode} qc_game.nodePool.find('${item}').${
              act.method
            }(${resolveActionParam(act.method, act.param)})\n`
          })
        } else {
          actionCode += `${awaitCode} qc_game.nodePool.find('${act.node}').${
            act.method
          }(${resolveActionParam(act.method, act.param)})\n`
        }
      }
    } else {
      if (isIvPage() && act.method === 'vpResumeVideo') {
        // 互动视频项目不用编译[继续播放视频]响应动作,由时间轴控制
        return
      }
      if (act.targetList && act.targetList.length > 0) {
        act.targetList.forEach((item) => {
          actionCode += `${awaitCode} qc_game.nodePool.find('${
            item
          }').getScript('${act.script}').${act.method}(${resolveActionParam(
            act.method,
            act.param,
          )})\n`
        })
      } else {
        actionCode += `${awaitCode} qc_game.nodePool.find('${
          act.node
        }').getScript('${act.script}').${act.method}(${resolveActionParam(
          act.method,
          act.param,
        )})\n`
      }
    }
  })
  return actionCode
}

/**
 * 解析单个ast事件到VPComponent代码中
 * @param {String} scriptCode
 * @param {*} param1
 */
function resolveVPEvent(
  scriptCode,
  { condition, action, id, nodePool, once },
  eventItems,
) {
  const tempVarReplaceReg = new RegExp(
    `(// ## temp variable ##)([\\w\\W]*)(// ## temp variable ##)`,
  )
  const actionReplaceReg = new RegExp(
    `(// ## action ##)([\\w\\W]*)(// ## action ##)`,
  )
  const { conditionReplaceReg, conditionCode, defineTempVarCode } =
    resolveConditionCode(condition, nodePool, id)
  let actionCode = ''
  // 手势类型的条件默认可触发多次,如果只允许触发一次需要一开始就把条件id弄成false
  if (once && condition.length > 0 && condition[0].type === 'event') {
    actionCode += `this._${id} = false\n`
  }
  actionCode += resolveActionCode(action, eventItems)
  // 全局变量判定的条件默认只除非一次，如果允许触发多次，需要在最后把条件id弄成true
  if (!once && condition.every((item) => item.type === 'compare')) {
    actionCode += `this._${id} = true\n`
  }
  const eventCode = `
  // ${id}
  ${conditionCode.replace(actionReplaceReg, `${actionCode}`)}
  // ${id}
  `
  return scriptCode
    .replace(conditionReplaceReg, `$1$2 ${eventCode} $3`)
    .replace(tempVarReplaceReg, `$1$2 ${defineTempVarCode} $3`)
}

export function resolveVPName(qcNode) {
  const isNormMaterial = store.state.workspace.project.isNormMaterial
  const length = !isNormMaterial ? 10 : 8
  const scriptName = `VPComponent_${qcNode.uuid.slice(0, length)}`.replace(
    '-',
    '',
  )
  const scriptPath = `./Scripts/vp/${scriptName}.js`
  const className = `ps.${scriptName}`
  return {
    scriptName,
    scriptPath,
    className,
  }
}

let vpTemplateCode = '' // 缓存VPComponent.js
async function getVPTemplateCode(scriptName) {
  if (vpTemplateCode === '') {
    const templateScriptPath = 'Scripts/vp/VPComponent.js'
    let code = await readFile({
      pid: router.currentRoute.query.id,
      path: templateScriptPath,
    })
    vpTemplateCode = code
    if (scriptName) {
      code = code.replace(/VPComponent/g, scriptName)
    }
    return code
  }
  let code = vpTemplateCode
  if (scriptName) {
    code = vpTemplateCode.replace(/VPComponent/g, scriptName)
  }
  return code
}

/**
 * 深度遍历当前场景节点,删除vpHand
 */
async function cleanVPScript(sceneNode) {
  await DFS(sceneNode, (node) => {
    const hand = node.getScript('ps.VPHand')
    const drager = node.getScript('ps.Drager')
    if (hand && hand.version === VERSION) {
      node.removeScript(hand)
    }
    if (drager && drager.version === VERSION) {
      node.removeScript(drager)
    }
  })
}

const visualProgram = {
  namespaced: true,

  state: {
    backupAST: null,
    ast: null,
    lock: false, // 锁定事件表，防止意外重写
    globalVar: [],
    supportGlobalVar: true,
    filterCategories: [], // 筛选的动作列表
    actionEventList: [], // 新版ps记录当前场景筛选后的动作列表
    actionEventListAll: [], // 新版ps记录所有场景的动作列表
    editActionId: '',
    addActionId: '',
    sourcedSendAction: '', // 定位发送埋点

    // 当前事件需要高亮的事件数据（暂时用在故事板中）
    currentEventData: {
      actionIds: null,
      eventIds: null,
    },
    // 当前节点事件配置
    currentEventList: [],
  },

  mutations: {
    updateCurrentEventData(state, val) {
      state.currentEventData = val
    },

    updateSourcedSendAction(state, val) {
      state.sourcedSendAction = val
    },

    updateEditActionId(state, value) {
      state.editActionId = value
    },
    updateAddActionId(state, value) {
      state.addActionId = value
    },
    notSupportGlobalVar(state) {
      state.supportGlobalVar = false
    },

    updateAst(state, { ast }) {
      state.ast = ast
    },
    // 整组更新
    updateAction(state, { astIndex, action }) {
      state.ast[astIndex].action = action
    },
    // 整组更新
    updateCondition(state, { astIndex, condition }) {
      state.ast[astIndex].condition = condition
    },
    deleteAction(state, { astIndex, actionIndex }) {
      const astItem = state.ast[astIndex]
      astItem.action.splice(actionIndex, 1)
    },
    deleteActionById(state, { eventId, actionId }) {
      const astIndex = state.ast.findIndex((item) => item.id === eventId)
      const astItem = state.ast[astIndex]
      const actionIndex = astItem.action.findIndex(
        (item) => item.id === actionId,
      )
      astItem.action.splice(actionIndex, 1)
    },
    deleteCondition(state, { astIndex, conditionIndex }) {
      const astItem = state.ast[astIndex]
      astItem.condition.splice(conditionIndex, 1)
    },
    deleteEventItem(state, { astIndex }) {
      state.ast.splice(astIndex, 1)
    },
    copyEventItem(state, { astIndex }) {
      const _astItem = cloneDeep(state.ast[astIndex])
      _astItem.id = generateUUID()
      state.ast.push(_astItem)
    },
    disableEventItem(state, { astIndex, disabled }) {
      Vue.set(state.ast[astIndex], 'disabled', disabled)
    },
    addEventItem(state, { condition }) {
      const astItem = astItemFactory(condition)
      state.ast.push(astItem)
    },
    addEventItemByIndex(state, { ast, index }) {
      if (typeof index === 'undefined') {
        index = state.ast.length
      }
      state.ast.splice(index, 0, ast)
    },
    addCondition(state, { astIndex, condition, index }) {
      if (!Array.isArray(state.ast[astIndex].condition))
        state.ast[astIndex].condition = []
      if (typeof index === 'undefined') {
        state.ast[astIndex].condition.push(condition)
      } else {
        state.ast[astIndex].condition.splice(index, 0, condition)
      }
    },
    addAction(state, { astIndex, action, index }) {
      if (!Array.isArray(state.ast[astIndex].action))
        state.ast[astIndex].action = []
      if (typeof index === 'undefined') {
        state.ast[astIndex].action.push(action)
      } else {
        state.ast[astIndex].action.splice(index, 0, action)
      }
    },
    editAction(state, { astIndex, actionIndex, action }) {
      const astItem = state.ast[astIndex]
      astItem.action.splice(actionIndex, 1, action)
    },
    editCondition(state, { astIndex, conditionIndex, condition }) {
      const astItem = state.ast[astIndex]
      astItem.condition.splice(conditionIndex, 1, condition)
    },
    editConditionForCompare(state, { eventId, compareIndex, condition }) {
      const index = state.ast.findIndex((item) => item.id === eventId)
      state.ast[index].condition.splice(compareIndex, 1, condition)
      state.ast = cloneDeep(state.ast) // 编辑条件中某个比较参数不会触发ast的响应式，暂时用ast克隆来触发响应式
    },
    // 取消，备份
    backup(state) {
      state.backupAST = cloneDeep(state.ast)
    },
    rollback(state) {
      state.ast = cloneDeep(state.backupAST)
    },
    updateVpAstLock(state, { lock }) {
      state.lock = lock
    },

    updateActionEventList(state, { actionEventList }) {
      state.actionEventList = actionEventList
    },

    updateActionEventListAll(state, { actionEventListAll }) {
      state.actionEventListAll = actionEventListAll
    },

    // 更新当前节点的事件列表
    updateCurrentEventList(state, { eventList }) {
      state.currentEventList = eventList || []
    },
    updateFilterCategories(state, { categories }) {
      state.filterCategories = categories
    },
  },

  actions: {
    saveVpAst({ state }, { node, ast }) {
      const editorData = node.getScript('playsmart.editor.data')
      if (!editorData) {
        node.addScript('playsmart.editor.data')
        node.getScript('playsmart.editor.data').vpAst = ast
      } else {
        editorData.vpAst = ast
      }
    },
    saveAST(
      { state, commit, rootState, dispatch },
      { ast, sceneNode, noAstUpdate } = {},
    ) {
      ast = ast || state.ast
      if (!noAstUpdate) {
        commit('updateAst', { ast })
        commit('backup')
      }
      const currentSceneNode =
        rootState.workspace.game.sceneManager.currentSceneNode
      const node = sceneNode || currentSceneNode
      const activeNode = rootState.workspace.game.activeNode
      dispatch('saveVpAst', { node, ast })
      // 更新故事板的边
      store.dispatch('workspace/storyboard/renderEdges', {
        sceneId: node.uuid,
        id: activeNode ? activeNode.uuid : node.uuid,
      })
    },
    initAST({ commit, rootState }) {
      const currentSceneNode =
        rootState.workspace.game.sceneManager.currentSceneNode
      const ast = getVpAstFromSceneNode(currentSceneNode)
      const lock = getVpAstLockFromSceneNode(currentSceneNode)
      commit('updateAst', { ast })
      commit('updateVpAstLock', { lock })
      commit('backup')
      return ast
      /**
       * 手势条件
       * {
       *  id:'i1u2h3iu',
       *  targetLabel: '手势',
       *  conditionLabel: '点击',
       *  node: '/',
       *  type: 'event',
       *  content: 'CLICK'
       * }
       *
       * 比较自定义变量条件
       * {
       *  id: 'byu234uo',
       *  targetLabel: '系统',
       *  conditionLabel: '比较自定义变量',
       *  node: '/',
       *  type: 'compare',
       *  content: {
       *    compareData1: {
       *      targetNodeScript: 'ps.VPComponent_32oij341',
       *      targetNode: '/abc',
       *      data: 'clickTimes'
       *    },
       *    compareMethod: '>=',
       *    compareData2: {
       *      targetNodeScript: '',
       *      targetNode: '', p
       *      data: 2
       *    },
       *  }
       * }
       *
       * 龙骨播放动画动作
       * {
       *  targetLabel: '节点1',
       *  actionLabel: '播放动画',
       *  node: 'dg1',
       *  script: 'qc.Animator',
       *  method: 'play',
       *  param: {
       *    'animationName': 'ani1'
       *  }
       * }
       *
       * 数值运算动作
       * {
       *  targetLabel: '系统',
       *  actionLabel: '数值运算',
       *  node: '/',
       *  script: 'ps.VPComponent_oi12j312',
       *  method: 'compute',
       *  param: {
       *    target: 'clickTime',
       *    method: '+',
       *    value: 1
       *  }
       * }
       */

      // ast = [
      //   {
      //     id: '',
      //     condition: [
      //       {

      //       }
      //     ],
      //     action: [
      //       {

      //       }
      //     ]
      //   }
      // ]
    },
    async ensureVPComponent({ commit, state, rootState }, { qcNode }) {
      const projectKey = router.currentRoute.query.id
      const { scriptName, scriptPath, className } = resolveVPName(qcNode)
      const qcComponent = _.get(
        rootState.workspace.game.iframeWindow,
        className,
      )
      if (typeof qcComponent === 'undefined') {
        const scriptCode = await getVPTemplateCode(scriptName)
        await saveFile({ pid: projectKey, path: scriptPath }, scriptCode)
        await reloadScript({ projectKey, src: scriptPath })
        qcNode.addScript(className)
      }
    },
    /**
     * @description 复制场景后修改场景的vpAst
     * @param {object}  { rootState, state }
     * @param {object} node 场景节点
     * @returns {Promise} Promise 对象
     */
    async copySceneVpAst({ rootState, state }, { node }) {
      const ignoreReplaceKey = ['jumpSceneId']
      const { nodePool } = rootState.workspace.game.data.gameObj
      const ped = node.getScript('playsmart.editor.data')
      const gamePlay = getGamePlay()

      if (ped) {
        const vpAst = ped.vpAst
        const copyVpAst = cloneDeep(vpAst)

        const deepReplaceUUID = ({ copyVpAst, sceneNode, nodePool }) => {
          for (const key in copyVpAst) {
            if (
              /^\[object (Array|Object)\]$/.test(
                Object.prototype.toString.call(copyVpAst[key]),
              )
            ) {
              deepReplaceUUID({
                copyVpAst: copyVpAst[key],
                sceneNode,
                nodePool,
              })
            }

            // 修改拷贝节点指向的UUID
            if (isUUID(copyVpAst[key]) && !ignoreReplaceKey.includes(key)) {
              const targetNode = nodePool.find(copyVpAst[key])
              // gamePlay节点不用改
              // eslint-disable-next-line
              if (!targetNode || targetNode === gamePlay) continue
              const path = getRouteIndexByNodeInScene(targetNode)
              const child = findChildByRouteIndexInScene(
                sceneNode,
                path,
              )
              if (child) {
                copyVpAst[key] = child.uuid
              }
            }
            // 修改拷贝节点对应的scrip字段（ps.VPComponent_xxx）
            if (isVPComponent(copyVpAst[key])) {
              const targetNode = nodePool.find(copyVpAst[key])
              // gamePlay节点不用改
              // eslint-disable-next-line
              if (!targetNode || targetNode === gamePlay) continue
              const path = getRouteIndexByNodeInScene(targetNode)
              const { className } = resolveVPName(
                findChildByRouteIndexInScene(sceneNode, path),
              )
              copyVpAst[key] = className
            }
          }
        }
        // 拖曳区域的数据改成新的
        const dragTargetAreaReplace = ({ copyVpAst }) => {
          for (const key in copyVpAst) {
            for (const i in copyVpAst[key].condition) {
              if (
                copyVpAst[key].condition[i].content ===
                DragConditionType.VPDRAG_END || copyVpAst[key].condition[i].content ===
                DragConditionType.VPUNDRAG_END
              ) {
                let oriUuid, newUuid
                if (copyVpAst[key].condition[i].node2) {
                  newUuid = generateUUID()
                  oriUuid = copyVpAst[key].condition[i].node2
                  copyVpAst[key].condition[i].node2 = newUuid
                }
                if (
                  copyVpAst[key].condition[i].ext &&
                  copyVpAst[key].condition[i].ext.dragTargetArea &&
                  copyVpAst[key].condition[i].ext.dragTargetArea[oriUuid]
                ) {
                  copyVpAst[key].condition[i].ext.dragTargetArea[newUuid] =
                    cloneDeep(
                      copyVpAst[key].condition[i].ext.dragTargetArea[oriUuid],
                    )
                  delete copyVpAst[key].condition[i].ext.dragTargetArea[oriUuid]
                }
              }
            }
          }
        }
        // 复制场景时需要生成新的事件id
        const replaceEventId = ({ copyVpAst }) => {
          for (let i in copyVpAst) {
            const id = generateUUID()
            const oriId = copyVpAst[i].id
            for (let j in copyVpAst) {
              copyVpAst[j].action.forEach((action) => {
                if (
                  action.method === 'enabledEvent' ||
                  action.method === 'enabledEventActive' ||
                  action.method === 'enabledEventBan'
                ) {
                  if (action.param.eventId === oriId) {
                    action.param.eventId = id
                  }
                }
              })
            }
            copyVpAst[i].id = id
          }
        }

        replaceEventId({ copyVpAst })
        deepReplaceUUID({ copyVpAst, sceneNode: node, nodePool })
        dragTargetAreaReplace({ copyVpAst })
        // 连线组件数据联动,不用改配对的uuid,主要是设置子节点的matchNodes
        if (hasDrawLineConnectInScene(node)) {
          store.dispatch('workspace/game/drawLine/initData', node)
          store.dispatch('workspace/game/drawLine/updateScriptData', node)
        }
        ped.vpAst = copyVpAst
      }
    },

    /**
     * 删除项目中对应节点的VPComponent.js
     * @param qcNode qc.node
     * @param isDeleteResource 是否删除脚本文件
     * @returns {Promise<void>}
     */
    async deleteVPComponent(
      { rootState },
      { qcNode, isDeleteResource = true, isDeleteScript = true },
    ) {
      const projectKey = router.currentRoute.query.id
      const { scriptPath } = resolveVPName(qcNode)
      isDeleteResource &&
        (await this.dispatch('workspace/resource/deleteResource', {
          projectKey,
          path: scriptPath,
          recursive: 0,
        }))
      isDeleteScript && (await deleteScript({ projectKey, src: scriptPath }))
    },

    /**
     * @description 解析ast树并写入 VPComponent_xxx.js
     */
    async resolveAST({ state, rootState, dispatch }, { sceneNode } = {}) {
      if (state.lock) return
      const currentSceneNode =
        sceneNode || rootState.workspace.game.sceneManager.currentSceneNode
      if (!currentSceneNode) {
        return
      }
      const currentAst = cloneDeep(getVpAstFromSceneNode(currentSceneNode))
      const isNormMaterial = store.state.workspace.project.isNormMaterial
      const { nodePool } = rootState.workspace.game.data.gameObj
      const projectKey = router.currentRoute.query.id

      // 根据节点解析他应该的VPComponent类名
      const { scriptName, scriptPath, className } =
        resolveVPName(currentSceneNode)

      // 获取VPComponent模板脚本代码
      let scriptCode = await getVPTemplateCode(scriptName)

      // 获取到ast中启用状态的事件
      const enabledEvents = currentAst.filter((event) => !event.disabled)

      // 去除空condition
      const ansEvents = enabledEvents.filter(
        (event) => event.condition.length > 0,
      )

      // 先清除场景中所有节点的vpHand脚本
      if (isNormMaterial) {
        await cleanVPScript(currentSceneNode)
      }

      // 根据事件表内容 Hard Code 到代码
      for (const { condition, action, id, once } of ansEvents) {
        scriptCode = resolveVPEvent(
          scriptCode,
          { condition, action, id, nodePool, once },
          ansEvents,
        )
      }
      scriptCode = resolveTimeline(scriptCode, currentSceneNode)
      // 保存生成的VPComponent_xxx.js
      await saveFile({ pid: projectKey, path: scriptPath }, scriptCode)

      // 重新加载脚本
      await reloadScript({ projectKey, src: scriptPath })

      // 移除节点上的所有VPComponent
      if (isNormMaterial) {
        qcNodeRemoveScript(currentSceneNode, 'ps.VPComponent')
      }

      // 重新加载节点上的script
      qcNodeReloadScript(currentSceneNode, className)

      // 解析全局变量
      if (rootState.workspace.globalVar.supportGlobalVar) {
        await dispatch('resolveGlobalVar')
      }
    },

    /**
     * @description 移除节点时的ast相关处理
     */
    async removeNode({ commit, dispatch, state }, { uuid }) {
      let ast = state.ast
      const node = nodePool.find(uuid)
      // 删除对应的启用禁用事件
      const eventItemIds = ast
        .filter((astItem) => {
          if (
            astItem.condition &&
            astItem.condition.length > 0 &&
            astItem.condition[0].node === uuid
          ) {
            return true
          }
          return false
        })
        .map((item) => item.id)
      if (eventItemIds.length > 0) {
        ast.forEach((astItem) => {
          astItem.action = astItem.action.filter((act) => {
            if (
              (act.method === 'enabledEvent' ||
                act.method === 'enabledEventActive' ||
                act.method === 'enabledEventBan') &&
              eventItemIds.includes(act.param.eventId)
            ) {
              return false
            }
            return true
          })
        })
      }

      // 把包含移除的节点的事件筛掉
      ast.forEach((astItem) => {
        astItem.condition = astItem.condition.filter(
          (con) => !hasValue(con, uuid),
        )
        astItem.action.forEach((action) => {
          if (action.targetList && action.targetList.length > 0) {
            action.targetList = action.targetList.filter((target) => target !== uuid)
            action.paramLabelUI = getParamLabelUI(action.targetList)
          }
          if (action.node === uuid && action.targetList && action.targetList.length > 0) {
            action.node = action.targetList[0]
          }
        })
        astItem.action = astItem.action.filter((act) => !hasValue(act, uuid))
        // 删除起止区域时联动删除响应动作里的起止区域数据
        if (isDrawLineAreaNode(node)) {
          astItem.action.forEach((act) => {
            if(act.script === scripts.drawLine.name && act.param && act.param.area) {
              act.param.area = act.param.area.filter((area) => area !== node.name)
            }
          })
        }
        // 删除节点时，[分组类的动画]联动删除
        const list = [
          VpTweenMethods.vpPlayTweenChildrenAll,
          VpTweenMethods.vpStopTweenChildrenAll,
          VpTweenMethods.vpPlayTweenChildrenAllGoOn,
        ]
        astItem.action = astItem.action.filter((act) => {
          if (list.indexOf(act.method) > -1) {
            const node = nodePool.find(act.node)
            const nodes = getDescendants(node)
            const hasTween = nodes.some((tnode) => tnode.getScript('qc.Tween'))
            if (hasTween) {
              return true
            } else {
              return false
            }
          }
          return true
        })
      })

      const sceneList = iframe.gamePlay.children

      sceneList.forEach((sceneNode) => {
        const vpAst = getVpAstFromSceneNode(sceneNode)
        vpAst.forEach((astItem) => {
          astItem.condition = astItem.condition.filter(
            (con) => !hasValue(con, uuid),
          )
          astItem.action.forEach((action) => {
            if (action.targetList && action.targetList.length > 0) {
              action.targetList = action.targetList.filter((target) => target !== uuid)
              action.paramLabelUI = getParamLabelUI(action.targetList)
            }
            if (action.node === uuid && action.targetList && action.targetList.length > 0) {
              action.node = action.targetList[0]
            }
          })
          astItem.action = astItem.action.filter((act) => !hasValue(act, uuid))
        })
      })
      ast = ast.filter((item) => item.condition.length > 0)
      dispatch('saveAST', { ast })

      // await dispatch('resolveAST')
    },
    /**
     * @description 删除动画时的ast相关处理
     */
    async removeActionsByAnimation(
      { commit, dispatch, state },
      { actionsWithAnimation, actionsWithVpPlayTweenAnimation, node },
    ) {
      let action
      if (node.getScripts('qc.Tween').length === 0) {
        // 所有的动画都已被删除
        action = [
          ...actionsWithAnimation.action,
          ...actionsWithVpPlayTweenAnimation.action,
        ]
      } else {
        action = actionsWithAnimation.action
      }
      action
        .sort((a, b) => b.index - a.index)
        .forEach((act) => {
          // sort用于避免下方splice的index问题
          const { index, astIndex, sceneId } = act
          const sceneNode = nodePool.find(sceneId)
          const ast = getVpAstFromSceneNode(sceneNode)
          const _action = ast[astIndex].action[index]
          if (_action.targetList && _action.targetList.length > 0) {
            _action.targetList = _action.targetList.filter((target) => target !== node.uuid)
            _action.paramLabelUI = getParamLabelUI(_action.targetList)
          }
          if (_action.node === node.uuid && _action.targetList && _action.targetList.length > 0) {
            _action.node = _action.targetList[0]
          }
          if (!_action.targetList || _action.targetList.length === 0) {
            ast[astIndex].action.splice(index, 1)
          }
          dispatch('saveVpAst', { node: sceneNode, ast })
        })
    },
    // 删除动画时联动删除【分组里子节点的动画】
    async removeTweenChildrenAllActions({ commit, dispatch, state },{
      actionsWithTweenChildrenAll,
    }) {
      if (actionsWithTweenChildrenAll.length === 0) {
        return
      }
      const sceneNode = nodePool.find(actionsWithTweenChildrenAll[0].sceneId)
      const ast = getVpAstFromSceneNode(sceneNode)
      actionsWithTweenChildrenAll.forEach(act => {
        const { astIndex, index } = act
        if (act.value.targetList && act.value.targetList.length > 0) {
          act.value.targetList = act.value.targetList.filter((uuid) => {
            const node = nodePool.find(uuid)
            const nodes = getDescendants(node)
            const hasTween = nodes.some((tnode) => tnode.getScript('qc.Tween'))
            return hasTween
          })
          ast[astIndex].action[index].targetList = act.value.targetList
          act.value.paramLabelUI = getParamLabelUI(act.value.targetList)
          ast[astIndex].action[index].paramLabelUI = act.value.paramLabelUI
          if (act.value.targetList.indexOf(act.value.node) === -1) {
            if (act.value.targetList.length > 0) {
              act.value.node = act.value.targetList[0]
              ast[astIndex].action[index].node = act.value.node
            } else {
              ast[astIndex].action = ast[astIndex].action.filter(action => action.uuid !== act.value.uuid)
            }
          }
        } else {
          const node = nodePool.find(act.value.node)
          const nodes = getDescendants(node)
          const hasTween = nodes.some((tnode) => tnode.getScript('qc.Tween'))
          if (!hasTween) {
            ast[astIndex].action = ast[astIndex].action.filter(action => action.uuid !== act.value.uuid)
          }
        }
      })
      dispatch('saveVpAst', { node: sceneNode, ast })
    },
    /**
     * @description 恢复节点时的ast相关处理
     */
    async recoverNode({ commit, dispatch, state }, { eventsToNode }) {
      const condition = eventsToNode.condition
      const action = eventsToNode.action
      condition.forEach((con) => {
        const { index, value, astIndex, sceneId } = con
        const sceneNode = nodePool.find(sceneId)
        const ast = getVpAstFromSceneNode(sceneNode)
        ast[astIndex].condition.splice(index, 0, value)
        dispatch('saveVpAst', { node: sceneNode, ast })
      })
      action.forEach((act) => {
        const { index, value, astIndex, sceneId } = act
        const sceneNode = nodePool.find(sceneId)
        const ast = getVpAstFromSceneNode(sceneNode)
        ast[astIndex].action.splice(index, 0, value)
        dispatch('saveVpAst', { node: sceneNode, ast })
      })
    },
    // 替换动画时ast相关处理
    async updateActionBySwitchAnimation(
      { commit, dispatch, state },
      { animations, newAnimations },
    ) {
      const sceneList = iframe.gamePlay.children
      const animationsUuid = animations.map((animation) =>
        animation.builtinId ? animation.builtinId : animation.uuid,
      ) //uuid->builtinId
      const newAnimationsUuid = newAnimations.map((animation) =>
        animation.builtinId ? animation.builtinId : animation.uuid,
      ) //uuid->builtinId
      sceneList.forEach((sceneNode) => {
        const vpAst = getVpAstFromSceneNode(sceneNode)
        vpAst.forEach((astItem) => {
          astItem.action.forEach((action) => {
            if (!action.param) return
            const index = animationsUuid.findIndex(
              (uuid) => uuid === action.param.vpTweenUuid,
            )
            if (index > -1) {
              action.param.vpTweenUuid = newAnimationsUuid[index] //在复合动画中，vpTweenUuid对应的是builtinId而不是_uuid，故修改上方
            }
          })
        })
        dispatch('saveVpAst', { node: sceneNode, ast: vpAst })
      })
    },
    // 删除区域时,开始画线条件里对应的区域也要删除
    async removeDrawLineAreaForEvent(
      { commit, dispatch, state, rootState },
      { node },
    ) {
      const sceneNode = rootState.workspace.game.sceneManager.currentSceneNode
      const ast = getVpAstFromSceneNode(sceneNode)
      ast.forEach((astItem, astIndex) => {
        astItem.condition.forEach((condition) => {
          if (condition.drawLineStartNode) {
            condition.drawLineStartNode = condition.drawLineStartNode.filter(n => n != node.name)
          }
        })
      })
      dispatch('saveVpAst', { node: sceneNode, ast })
    },

    async removePairDataForEvent({ commit, dispatch, state, rootState }, { uuid }) {
      const sceneNode = rootState.workspace.game.sceneManager.currentSceneNode
      const ast = getVpAstFromSceneNode(sceneNode)
      ast.forEach((astItem, astIndex) => {
        astItem.condition.forEach((condition) => {
          if (condition.pairsUuid) {
            condition.pairsUuid = condition.pairsUuid.filter(id => id != uuid)
          }
        })
        astItem.action.forEach((action) => {
          if (action.param && action.param.pair)
          action.param.pair = action.param.pair.filter(p => p !== uuid)
        })
      })
      dispatch('updateParamUI')
      dispatch('saveAST', { sceneNode, ast })
    },
    // 删除配对类别数据联动
    async removePairCategoryForEvent({ dispatch ,rootState }, { pairCategory }) {
      const sceneNode = rootState.workspace.game.sceneManager.currentSceneNode
      const ast = getVpAstFromSceneNode(sceneNode)
      ast.forEach((astItem) => {
        astItem.condition.forEach((condition) => {
          if (condition.pairCategory === pairCategory) {
            condition.pairCategory = null
          }
        })
      })
      dispatch('saveAST', { sceneNode, ast })
    },

    /**
     * @description 把用户定义
     * 的全局变量解析成代码 hard code 到VPGamePlay中
     */
    async resolveGlobalVar({ state, rootGetters }) {
      const projectKey = router.currentRoute.query.id
      const VPGamePlayPath = './Scripts/vp/VPGamePlay.js'
      const globalVar = store.state.workspace.globalVar.globalVar
      const VPGamePlayCode = await getVPGamePlayCode()
      const gamePlay = rootGetters['workspace/game/gamePlay']

      await saveFile(
        { pid: projectKey, path: VPGamePlayPath },
        resolveGlobalVarCode(globalVar, VPGamePlayCode),
      )
      await reloadScript({ projectKey, src: VPGamePlayPath })
      qcNodeReloadScript(gamePlay, 'ps.VPGamePlay')
    },

    /**
     * @description 从VPGamePlay中初始化全局变量数据
     */
    async initGlobalVar({ state, rootGetters, commit }) {
      const supportGlobalVar = await checkGlobalVarSupport()
      store.commit(
        'workspace/globalVar/updateSupportGlobalVar',
        supportGlobalVar,
      )
      if (!supportGlobalVar) {
        commit('notSupportGlobalVar')
        return
      }
      const gamePlay = rootGetters['workspace/game/gamePlay']
      if (!gamePlay) return
      const VPGamePlay = gamePlay.getScript('ps.VPGamePlay')
      if (!VPGamePlay) return
      const desc = (await getGlobalVarDesc()) || {}
      let globalVar
      if (VPGamePlay.playsmartGlobalVars) {
        globalVar = Object.values(VPGamePlay.playsmartGlobalVars)
      } else {
        globalVar = Object.entries(VPGamePlay.serializableFields)
          .filter(
            ([key, value]) => key !== 'timers' && key !== 'playsmartGlobalVars',
          )
          .map(([key, typeValue]) => ({
            globalVarKey: key,
            type: VPvariableDataType.find(
              (v) => v.serializerTypeValue === typeValue,
            ).type,
            value: VPGamePlay[key],
            desc: desc[key],
          }))
      }
      store.commit('workspace/globalVar/updateGlobalVar', globalVar)
    },
    /**
     * 解析所有ast树到VPComponent.js
     */
    async resolveASTs({ dispatch }) {
      const gamePlay = getGamePlay()
      const promiseArr = []
      for (const i in gamePlay.children) {
        promiseArr.push(
          dispatch('resolveAST', { sceneNode: gamePlay.children[i] }),
        )
      }
      await Promise.all(promiseArr)
    },
    // 更新事件系统的显示UI
    async updateParamUI({ rootState, state }) {
      const gamePlay = getGamePlay()
      const nodePool = rootState.workspace.game.data.gameObj.nodePool
      for (const i in gamePlay.children) {
        const sceneNode = gamePlay.children[i]
        const asts = sceneNode.getScript(
          'playsmart.editor.data',
        ).vpAst
        for (const j in asts) {
          asts[j].action.forEach((action) => {
            if (action.paramLabel === 'target') {
              if (action.targetList && action.targetList.length > 0) {
                action.paramLabelUI = action.targetList.map((item) => {
                  const node = nodePool.find(item)
                  return i18nLayerName(item.uuid, node.name)
                }).join(',')
              } else if (action.node) {
                const tnode = nodePool.find(action.node)
                if (tnode) {
                  action.paramLabelUI = i18nLayerName(tnode.uuid, tnode.name)
                } else {
                  action.paramLabelUI = ''
                }
              } else {
                action.paramLabelUI = ''
              }
            } else if (action.paramLabel === 'none') {
              action.paramLabelUI = ''
            } else {
              let paramLabelUI = ''
              const actionEventConfig = getActionEventConfig(
                action,
                state.actionEventListAll,
              )
              if (actionEventConfig && actionEventConfig.paramParseFunc) {
                const actionI18nConfig = getVpAstActionConfig()
                const lang = language.get()
                if (Array.isArray(action.paramLabel)) {
                  const obj = {}
                  action.paramLabel.forEach((item) => {
                    obj[item] = action.param[item]
                  })
                  paramLabelUI = actionEventConfig.paramParseFunc(
                    obj,
                    actionI18nConfig,
                    sceneNode,
                    lang,
                  )
                } else {
                  paramLabelUI = actionEventConfig.paramParseFunc(
                    action.param[action.paramLabel],
                    actionI18nConfig,
                    sceneNode,
                    lang,
                  )
                }
                paramLabelUI = i18nParamParse(action, paramLabelUI)
              } else {
                paramLabelUI = action.param[action.paramLabel]
              }
              action.paramLabelUI = paramLabelUI
            }
            updateDrawLineParamLabel(action, sceneNode)
          })
        }
      }
    },
    // 添加事件 - 历史记录
    async addEventItem({ state }, { condition, sceneId }) {
      return executeAction({
        action: getAddEvent({
          newValue: { condition, sceneId },
          oldValue: { index: state.ast.length, sceneId },
        }),
        record: true,
      })
    },
    // 删除事件 - 历史记录
    async deleteEventItem({ state }, { id, ast, sceneId }) {
      return executeAction({
        action: getRemoveEvent({
          newValue: { eventId: id, sceneId },
          oldValue: { sceneId },
        }),
        record: true,
      })
    },
    // 编辑 action  - 历史记录
    async editActionHistory({ state }, { astIndex, actionIndex, action }) {
      const astItem = state.ast[astIndex]
      const oldAction = _.cloneDeep(astItem.action[actionIndex])
      return executeAction({
        action: getEventEditAction({
          newValue: { astIndex, actionIndex, action },
          oldValue: { astIndex, actionIndex, action: oldAction },
        }),
        record: true,
      })
    },
    // 新增 action - 历史记录
    async addActionHistory({ state }, { astIndex, action, sceneId }) {
      return executeAction({
        action: getEventAddActionHistory({
          newValue: { astIndex, action, sceneId },
          oldValue: { action, astIndex, sceneId },
        }),
        record: true,
      })
    },
    // 删除 action - 历史记录
    deleteActionHistory({ state }, { astIndex, actionIndex, sceneId }) {
      return executeAction({
        action: getEventRemoveActionHistory({
          newValue: { astIndex, actionIndex, sceneId },
          oldValue: { actionIndex, astIndex, sceneId },
        }),
        record: true,
      })
    },
    // 筛选 action - 历史记录
    filterActionHistory({ state }, filterCategories) {
      return executeAction({
        action: getChangeEventActionFilter({
          newValue: { filterCategories },
          oldValue: {
            filterCategories:
              store.state.workspace.game.visualProgram.filterCategories,
          },
        }),
        record: true,
      })
    },
    editorSwitchSceneActionById(
      { state, commit },
      { node, eventId, actionId, targetScene },
    ) {
      const astIndex = state.ast.findIndex((item) => item.id === eventId)
      const astItem = state.ast[astIndex]
      const actionIndex = astItem.action.findIndex(
        (item) => item.id === actionId,
      )
      let _action = state.ast[astIndex].action[actionIndex]
      const actionParams = { jumpSceneId: targetScene }
      // 将跳转场景的事件从A场景复制到B场景，跳转至下一场景的事件改为跳转为指定场景
      if (_action.method === VpMethods.vpSwitchNextScene) {
        _action = _.flatten(Object.values(state.actionEventListAll)).find(
          (action) => action.method === VpMethods.vpSwitchScene,
        )
        _action = cloneDeep(_action)
      }
      const actionEventConfig = getActionEventConfig(
        _action,
        state.actionEventListAll,
      )
      const action = makeAction({
        selectTarget: node,
        actionEvent: _action,
        actionParams,
        actionEventConfig,
      })
      commit('editAction', { astIndex, actionIndex, action })
    },
    // 批量删除actions  -- 故事板场景删除连线
    batchDelAction({ state }, { deleteActions, sceneId, record = true }) {
      return executeAction({
        action: getBatchDelActions({
          newValue: { deleteActions, sceneId },
          oldValue: { deleteActions, sceneId },
        }),
        record,
      })
    },
    // 将跳转事件移动到另外的场景 --- 故事板连线变换
    changeEventToOtherScene(
      { state },
      { actionData, node, targetSceneId, sceneId, record = true },
    ) {
      const ast = getVpAstFromSceneNode(
        iframe.gamePlay.children.find((node) => node.uuid === sceneId),
      )
      const editActions = actionData.map((actionItem) => {
        const astIndex = ast.findIndex((item) => item.id === actionItem.eventId)
        const astItem = ast[astIndex]
        const actionIndex = astItem.action.findIndex(
          (item) => item.uuid === actionItem.actionId,
        )
        let _action = ast[astIndex].action[actionIndex]
        const oldAction = cloneDeep(_action)
        const actionParams = { jumpSceneId: targetSceneId }
        // 将跳转场景的事件从A场景复制到B场景，跳转至下一场景的事件改为跳转为指定场景
        if (_action.method === VpMethods.vpSwitchNextScene) {
          _action = _.flatten(Object.values(state.actionEventListAll)).find(
            (action) => action.method === VpMethods.vpSwitchScene,
          )
          _action = cloneDeep(_action)
        }
        const actionEventConfig = getActionEventConfig(
          _action,
          state.actionEventListAll,
        )
        const newAction = makeAction({
          selectTarget: node,
          actionEvent: _action,
          actionParams,
          actionEventConfig,
        })
        return {
          astIndex,
          actionIndex,
          oldAction,
          newAction,
        }
      })
      return executeAction({
        action: getChangeEventToOtherSceneAction({
          newValue: { editActions, sceneId },
          oldValue: { editActions, sceneId },
        }),
        record,
      })
    },

    /**
     * 初始化时或新增删除节点时获取所有节点对应的事件动作列表的配置信息，用于改名等操作时需要刷新关联的事件系统的数据
     * @param state
     * @param commit
     */
    getAllActions({ state, commit }) {
      const nodes = getDescendants(iframe.gamePlay)
      let actionList = []
      nodes.forEach((node) => {
        actionList.push(getActionsFromNode(node))
      })
      actionList = actionList.flat()
      let actionList2 = []
      actionList.forEach((action) => {
        // 运算不加进动作列表
        if (action.category.indexOf('vp-param') > -1) {
          return
        }
        let exist = false
        for (const i in actionList2) {
          if (
            actionList2[i].script === action.script &&
            actionList2[i].method === action.method
          ) {
            exist = true
            break
          }
        }
        if (!exist) {
          actionList2.push(action)
        }
      })
      // 没有缓动动画时删掉分组动画系列的响应动作
      if (!actionList2.some((action) => action.script === 'qc.Tween')) {
        const groupTweenList = [VpTweenMethods.vpPlayTweenChildrenAll, VpTweenMethods.vpStopTweenChildrenAll, VpTweenMethods.vpPlayTweenChildrenAllGoOn]
        actionList2 = actionList2.filter((action) => groupTweenList.indexOf(action.method) === -1)
      }
      const ansActionList = {}
      actionList2.forEach((action) => {
        const category = action.category
        if (typeof ansActionList[category] === 'undefined') {
          ansActionList[category] = []
        }
        ansActionList[category].push(action)
      })
      commit('updateActionEventListAll', { actionEventListAll: ansActionList })
    },

    // 添加条件判断 - 历史记录
    async addCompareCondition({ state }, { condition, eventId, sceneId }) {
      return executeAction({
        action: getAddCompareCondition({
          newValue: { condition, eventId, sceneId },
          oldValue: { eventId, sceneId },
        }),
        record: true,
      })
    },

    // 编辑条件判断 - 历史记录
    async editCompareCondition(
      { state },
      { condition, compareIndex, eventId },
    ) {
      const astItem = state.ast.find((item) => item.id === eventId)
      const oldCondition = _.cloneDeep(astItem.condition[compareIndex])
      return executeAction({
        action: getEditCompareCondition({
          newValue: { condition, compareIndex, eventId },
          oldValue: { condition: oldCondition, compareIndex, eventId },
        }),
        record: true,
      })
    },

    // 删除条件判断 - 历史记录
    async deleteCompareCondition(
      { state },
      { compareIndex, eventId, sceneId },
    ) {
      return executeAction({
        action: getDeleteCompareCondition({
          newValue: { compareIndex, eventId, sceneId },
          oldValue: { compareIndex, eventId, sceneId },
        }),
        record: true,
      })
    },

    // 删除整份条件判断 - 历史记录
    async deleteCompareConditions({ state }, { eventId, sceneId }) {
      return executeAction({
        action: getDeleteCompareConditions({
          newValue: { eventId, sceneId },
          oldValue: { eventId, sceneId },
        }),
        record: true,
      })
    },

    // 编辑条件判断 - 历史记录
    async editConditionsForTypeChange({ state }, { cmd, eventId, sceneId }) {
      return executeAction({
        action: getEditConditionsForTypeChangeHistory({
          newValue: { cmd, eventId, sceneId },
          oldValue: { cmd, eventId, sceneId },
        }),
        record: true,
      })
    },

    // 编辑自定义事件的名字 - 历史记录
    async editEventName({ state }, { eventId, eventName }) {
      return executeAction({
        action: getEditEventNameHistory({
          newValue: { eventId, eventName },
          oldValue: { eventId, eventName },
        }),
        record: true,
      })
    },

    // 编辑条件 - 历史记录
    async editCondition(
      { state },
      { eventId, node, content },
    ) {
      return executeAction({
        action: getEditConditionHistory({
          newValue: { eventId, node, content },
          oldValue: { eventId },
        }),
        record: true,
      })
    },

    // 条件判断顺序前移后移 - 历史记录
    async sortCompareConditionEvent({ state }, { eventId, sortType }) {
      return executeAction({
        action: getSortCompareConditionEventHistory({
          newValue: { eventId, sortType },
          oldValue: { eventId },
        }),
        record: true,
      })
    },
  },
}

export default visualProgram
